"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const package_1 = require("../package");
const CheckoutModalStyle_1 = require("./jss/CheckoutModalStyle");
class CheckoutModal extends React.Component {
    constructor(props) {
        super(props);
        this.getOptionLabel = (option) => option.name;
        this.renderOption = (option) => (0, jsx_runtime_1.jsx)(React.Fragment, { children: option.name });
        this.renderInput = (params) => ((0, jsx_runtime_1.jsx)(core_1.TextField, Object.assign({}, params, { hiddenLabel: true, variant: 'outlined', inputProps: Object.assign(Object.assign({}, params.inputProps), { autoComplete: 'new-password' }) }), 'country'));
        this.iconRef = React.createRef();
    }
    render() {
        const { classes, paymentUrl } = this.props;
        return ((0, jsx_runtime_1.jsx)(package_1.InformationDialog, Object.assign({ open: this.props.open, onClose: this.props.onClose, hideButton: true, hideXButton: true, maxWidth: 'md', disableBackdropClick: true, noSpaces: true, disableHorizontalScroll: true, mobileFullScreen: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ container: true, spacing: 2, className: classes.content }, { children: (0, jsx_runtime_1.jsx)(core_1.Grid, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)("iframe", { title: "Payment", src: paymentUrl, allow: "autoplay", scrolling: "yes", id: 'iframe', className: classes.iframe }) })) })) })));
    }
}
exports.default = (0, core_1.withStyles)(CheckoutModalStyle_1.default)((0, react_i18next_1.withTranslation)()(CheckoutModal));
//# sourceMappingURL=CheckoutModal.js.map